"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsingError = void 0;
const Span = __importStar(require("../span"));
const base_error_1 = require("./base-error");
class ParsingError extends base_error_1.BaseError {
    constructor(message, opts) {
        super(message);
        this.message = message;
        this.span = opts.span;
    }
    report(context) {
        return [
            `I found syntax error in code:`,
            ``,
            Span.report(this.span, context),
            ``,
            this.concise_message,
        ].join("\n");
    }
    get concise_message() {
        const lines = this.message.split("\n");
        if (lines.length > 7) {
            return [
                // NOTE Show first 7 lines, for first three entres.
                // TODO This should be improved.
                ...lines.slice(0, 7),
                " and so on ...",
            ].join("\n");
        }
        else {
            return this.message;
        }
    }
}
exports.ParsingError = ParsingError;
//# sourceMappingURL=parsing-error.js.map